export const contactSalesFormViewed =
  'universal_help_contact_sales_form_viewed';

export const contactSalesFormCancelled =
  'universal_help_contact_sales_form_cancelled';

export const contactSalesFormSubmitted =
  'universal_help_contact_sales_form_submitted';

export const contactSalesFormSubmitError =
  'universal_help_contact_sales_form_submit_error';
